// extracted by mini-css-extract-plugin
export default {"wrapper":"Buttons_wrapper__tf+Bi","button":"Buttons_button__2PV1L"};